import * as React from 'react';

import { Button, ButtonContainer, Link, Spacer, Typography } from '@emburse/ui-core';

import { VerifyWithMicrodeposits } from '@Shared/interfaces/Stripe';

/**
 * Displays info about the Stripe microdeposit verification process
 * Includes buttons to take them to the actual Stripe-hosted verification page, and to cancel the verification process (allowing them to choose a different payment method)
 */
export const VerifyStripeBank: React.FC<{ verifyWithMicrodeposits: VerifyWithMicrodeposits; hideLogout?: boolean; onCancel: () => void }> =
  ({ verifyWithMicrodeposits, hideLogout, onCancel }) => {
    return (
      <>
        <Typography variant="subtitle1">Verify Your Bank Account</Typography>
        <Spacer direction="vertical" size={8} />
        <Typography>
          We've sent a micro-deposit of <b>$0.01</b> to your bank account. It may take <b>1-2 business days</b> to appear in your
          transactions
        </Typography>
        <Spacer direction="vertical" size={32} />
        <Typography variant="subtitle1">Next Steps</Typography>
        <Spacer direction="vertical" size={8} />
        <Typography>
          <ol style={{ marginTop: 0 }}>
            <li>
              Check your bank account for a <b>$0.01</b> deposit (this may take up to <b>2 business days</b>).
            </li>
            <li>
              Come back here and click <b>"Verify"</b> to complete your payment setup.
            </li>
          </ol>
        </Typography>
        <Spacer direction="vertical" size={16} />
        <Typography variant="subtitle1">Can't verify yet?</Typography>
        <Spacer direction="vertical" size={8} />
        <Typography>
          You can
          {hideLogout ? (
            ''
          ) : (
            <>
              {' '}
              <b>log out</b> and
            </>
          )}{' '}
          return later, or <b>cancel</b> if you need to use a different payment method.
        </Typography>
        <Spacer direction="vertical" size={32} />
        <div className="flex jc-sb">
          {hideLogout && <div />}
          {!hideLogout && (
            <Link href="/logout">
              <Button variant="text">Log out</Button>
            </Link>
          )}
          <ButtonContainer alignButtons="right">
            <Button onClick={onCancel} variant="outlined">
              Cancel
            </Button>
            <Link href={verifyWithMicrodeposits.hosted_verification_url}>
              <Button>Verify</Button>
            </Link>
          </ButtonContainer>
        </div>
      </>
    );
  };
